var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpenseLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_73_1238)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 18C43.52 18 38.6667 22.8533 38.6667 28.8333C38.6667 34.8133 43.52 39.6667 49.5 39.6667C55.48 39.6667 60.3333 34.8133 60.3333 28.8333C60.3333 22.8533 55.48 18 49.5 18ZM49.5 35.3333C45.9033 35.3333 43 32.43 43 28.8333C43 25.2367 45.9033 22.3333 49.5 22.3333C53.0967 22.3333 56 25.2367 56 28.8333C56 32.43 53.0967 35.3333 49.5 35.3333ZM56 48.3333H51.6667C51.6667 45.7333 50.0417 43.3933 47.615 42.4833L34.2683 37.5H17V61.3333H30V58.2133L45.1667 62.4167L62.5 57V54.8333C62.5 51.2367 59.5967 48.3333 56 48.3333ZM25.6667 57H21.3333V41.8333H25.6667V57ZM45.1017 57.8883L30 53.75V41.8333H33.4883L46.0983 46.535C46.835 46.8167 47.3333 47.5317 47.3333 48.3333C47.3333 48.3333 43 48.225 42.35 48.0083L37.1933 46.2967L35.8283 50.4133L40.985 52.125C42.09 52.4933 43.2383 52.6667 44.4083 52.6667H56C56.845 52.6667 57.6033 53.1867 57.95 53.9017L45.1017 57.8883Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_73_1238",
    x1: 0,
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB675"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpenseLight);
export default __webpack_public_path__ + "static/media/Icon-expense-light.f30ad7da78783798e41cb54ca2351955.svg";
export { ForwardRef as ReactComponent };